import React, { useEffect, createElement } from 'react';
import { SocialProofPopup } from './components/SocialProofPopup';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { CourseContents } from './components/CourseContents';
import { BeforeAfter } from './components/BeforeAfter';
import { TestimonialsSection } from './components/TestimonialsSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
declare global {
  interface Window {
    fbq: (...args: unknown[]) => void;
    _fbq: (...args: unknown[]) => void;
  }
}
export function App() {
  useEffect(() => {
    // Meta Pixel Code
    if (typeof window !== 'undefined' && !window.fbq) {
      const n: any = window.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!window._fbq) window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const s = document.getElementsByTagName('script')[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      }
      window.fbq('init', '702508242889939');
      window.fbq('track', 'PageView');
    }
    // Add noscript pixel
    const noscriptImg = document.createElement('img');
    noscriptImg.height = 1;
    noscriptImg.width = 1;
    noscriptImg.style.display = 'none';
    noscriptImg.src = 'https://www.facebook.com/tr?id=702508242889939&ev=PageView&noscript=1';
    document.body.appendChild(noscriptImg);
    return () => {
      if (noscriptImg.parentNode) {
        noscriptImg.parentNode.removeChild(noscriptImg);
      }
    };
  }, []);
  return <div className="w-full min-h-screen bg-white font-body" data-id="element-0">
      <SocialProofPopup data-id="element-1" />
      <HeroSection data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <SolutionSection data-id="element-4" />
      <CourseContents data-id="element-5" />
      <BeforeAfter data-id="element-6" />
      <TestimonialsSection data-id="element-7" />
      <BonusSection data-id="element-8" />
      <PricingSection data-id="element-9" />
      <GuaranteeSection data-id="element-10" />
      <FAQSection data-id="element-11" />
      <FinalCTA data-id="element-12" />
    </div>;
}